import { toCamelCaseObject } from "@/lib/util";

export class Group {
  /**
   * @param {Object} group
   * @param {String} group.id
   * @param {String} group.name
   * @param {ฺboolean} group.isAffectApp
   * @param {DateTime | null} group.deletedAt
   */
  constructor(group) {
    this.id = group.id;
    this.name = group.name;
    this.isAffectApp = group.isAffectApp;
    this.deletedAt = group.deletedAt;
  }

  /**
   * @param {import('./GroupResponse').GroupResponse} response
   *
   * @return {Group}
   */
  static createFromResponse(response) {
    const groupResponse = toCamelCaseObject(response);

    return new Group(groupResponse);
  }
}
